import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomerSearch from '@/components/VarausModal/components/CustomerSearch';
import CustomerForm from '@/components/VarausModal/components/CustomerForm';
import { useTranslation } from 'react-i18next';

const StepCustomerDetails = ({
  customerChoice,
  searchInput,
  setSearchInput,
  searchResults,
  searchLoading,
  selectedCustomer,
  customerForm,
  onSelectSearchResult,
  onFormChange,
  onFieldBlur,
  fieldErrors,
}) => {
  const showForm = customerChoice === 'new' || !!selectedCustomer;
  const { t } = useTranslation();

  return (
    <Box sx={{ py: 3 }}>
      {customerChoice === 'search'
        ? (
            <Box sx={{ pb: selectedCustomer ? 0 : 30 }}>
              <CustomerSearch
                searchInput={searchInput}
                setSearchInput={setSearchInput}
                searchResults={searchResults}
                searchLoading={searchLoading}
                selectedCustomer={selectedCustomer}
                onSelectResult={onSelectSearchResult}
              />
            </Box>
          )
        : (
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
              {t('varausModal.stepCustomerDetails.enterInfo')}
            </Typography>
          )}

      {
        showForm && (
          <CustomerForm
            customerForm={customerForm}
            onFormChange={onFormChange}
            onFieldBlur={onFieldBlur}
            fieldErrors={fieldErrors}
          />
        )
      }
    </Box>
  );
};

export default StepCustomerDetails;
